import React, { Component, useState } from "react";
import { withStore } from 'react-context-hook'
import { AppLoading } from "expo";
import Constants from 'expo-constants'
import { View, Text, Platform, Dimensions } from 'react-native';
import * as Font from "expo-font";
import { Assets } from 'expo-asset';
import RootDrawer from "./screens/DashboardScreen/index.js";
import SignOn from "./screens/Auth/index.js";
import { NavigationContainer } from '@react-navigation/native';
//import { firebaseConfig } from './utils';
import * as firebase from "firebase/app";
import "firebase/auth";
// import "firebase/firestore";
import Sentry from './utils/Sentry'

function App() {

  const [appReady, setAppReady] = useState(false)

  //loading fonts
  const fontsLoaded = Font.loadAsync({
      GlobalFontBold: require('./assets/fonts/KumbhSans-Bold.ttf'),
      GlobalFontLight: require('./assets/fonts/KumbhSans-Light.ttf'),
      GlobalFontRegular: require('./assets/fonts/KumbhSans-Regular.ttf'),
    })
  
  fontsLoaded.then(() => { 
    setAppReady(true)
  }).catch((error) => {
    alert(error)
    Sentry.captureException(error)
  })

  //initializing sentry
  Sentry.init({
    dsn: 'https://0ff2aaf881e74f31b949986cb98cb9da@o422293.ingest.sentry.io/5347317',
    enableInExpoDevelopment: true,
    enableNative: false,
    debug: true,
  });

  // TODO: add other assets here
  //setting assets loaded via the bundle 
  global.BackgroundImage = require('./assets/images/background.png')

  if(!appReady) {

    return (
      <AppLoading />
    )
  }
  
  Sentry.captureMessage('App loaded')
  return (
    <SignOn />
  )
}

const window = Dimensions.get("window");

const initialState = {
    enableConsoleLogging: true,
    enableSentryLogging: true,
    enableAlertLogging: false,
    platform: Platform.OS,
    desktopThreshold: 1024,
    displayDesktop: window.width > 1024 ? true : false,
    paidUser: true,
}

export default withStore(App, initialState)

